<template>
  <span v-if="params.data" class="w-full flex justify-between">
    <span>
      {{$options.filters.addComma((params.data || {}).filter_event || 0)}}
    </span>
    <span v-if="showDownloadIcon">
      <vs-icon icon="speakol-download" icon-pack="speakol" class="download" @click="isExportPopupActive = true"></vs-icon>
    </span>

    <SpeakolExport
      :fileName="leadFromExportedFileName"
      :isActive="isExportPopupActive"
      exportType="campaign-lead-forms"
      :params="exportParams"
      @hide="isExportPopupActive=false"
    />
  </span>
</template>

<script>
import SpeakolExport from  '@/components/SpeakolExport'
import leadFormExportFileName from '@/helpers/leadFormExportFileName.js'

export default {
  components: {
    SpeakolExport
  },
  data () {
    return {
      isExportPopupActive: false
    }
  },
  computed: {
    exportParams () {
      return {
        dateRange: this.params.context.parent.appliedFilters.dateRange,
        campaignId: this.params.data.id,
        event: this.params.context.parent.appliedFilters.event
      }
    },

    showDownloadIcon () {
      return this.params.data.objective_id === this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM
    },

    leadFromExportedFileName () {
      return leadFormExportFileName(this.params.data.name)
    }
  }
}
</script>

<style scoped lang="scss">
.download {
  font-size: 16px !important;

  @apply text-speakol-color cursor-pointer;
}
</style>
